import { createSelector } from "reselect";

// Selectors
import { createAllPageRevisionComparisonQuerySelector } from "..";

/**
 * create a selector to get the api context for all pages for revision comparison
 * @param {Object} props
 * @param {string} props.seriesId
 * @returns {function} selector
 */
export function createAllPageRevisionComparisonContextSelector({ seriesId }) {
  return createSelector(
    createAllPageRevisionComparisonQuerySelector({ seriesId }),
    queries => {
      return queries;
    }
  );
}
